import { FC } from 'react'

import { PromoAsset } from '@model/ReferralMaterialDto'

import { Loading } from '@shared/components/Loading/Loading'

import styles from './PromoPreviewModal.module.scss'

interface Props {
  isRefMaterialLoading: boolean
  selectedPromoAsset?: PromoAsset
}

export const PromoImagePreview: FC<Props> = ({ isRefMaterialLoading, selectedPromoAsset }) => {
  return (
    <section className={styles.promoImageContainer}>
      <Loading showLoadingIcon isLoading={isRefMaterialLoading}>
        <img
          src={selectedPromoAsset?.imagePath}
          alt={selectedPromoAsset?.name}
          className={styles.promoImage}
        />
      </Loading>
    </section>
  )
}
